import React from "react";
import changePasswordBanner from "../../../assets/images/changePasswordBanner.webp";
import ChangePassword from "./Content";
import AuthLayout from "../../../components/layout/AuthLayout";


const ChangePasswordPage = () => {
  return (
    <AuthLayout
      LeftComponent={ChangePassword}
      rightBgImage={changePasswordBanner}
    />
  );
};

export default ChangePasswordPage;